

import React, { useState, useEffect } from 'react';

import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';

import WebsiteVerificationCard from 'components/provider/WebsiteVerificationCard';
import GuestAPI from 'config/api/GuestAPI';

function getQueryParam(param) {
    const params = new URLSearchParams(window.location.search);
    return params.get(param);
}

export default function WebsiteVerification() {
    const [domain, setDomain] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [companyDetails, setCompanyDetails] = useState(null);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const qp = getQueryParam('domain');
        if (qp) {
            setDomain(qp);
            setLoading(true);
            setError('');
            const api = new GuestAPI();
            api.getCompany(qp)
                .then((company) => {
                    setCompanyDetails(company);
                    setSubmitted(true);
                })
                .catch(() => {
                    setError('Could not find a company for this domain. Please check the domain and try again.');
                })
                .finally(() => setLoading(false));
        }
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!domain) return;
        setLoading(true);
        setError('');
        const api = new GuestAPI();
        try {
            const company = await api.getCompany(domain);
			console.log('company: ', company);
			if (company) {
				setCompanyDetails(company);
            	setSubmitted(true);
			}
			else {
				setError('Could not find a company for this domain. Please check the domain and try again.');
			}
        } catch {
            setError('Could not find a company for this domain. Please check the domain and try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container maxWidth="lg" style={{ marginTop: 48 }}>
            <Box mb={4} textAlign="center">
                <Typography variant="h2" style={{ fontWeight: 700, marginBottom: 8 }}>
                    Website Badge Verification
                </Typography>
                <Typography variant="body1" color="textSecondary">
                    Enter your website domain to preview and verify your installer badge integration.
                </Typography>
            </Box>
            <Grid container justifyContent="center">
                {!submitted ? (
                    <Grid item xs={12} sm={8} md={6} lg={6} xl={6}>
                        <form onSubmit={handleSubmit}>
                            <Box mb={2}>
                                <OutlinedInput
                                    fullWidth
                                    placeholder="yourcompany.com"
                                    value={domain}
                                    onChange={e => setDomain(e.target.value)}
                                    autoFocus
                                    disabled={loading}
                                />
                            </Box>
                            <Button type="submit" variant="contained" color="primary" fullWidth disabled={!domain || loading}>
                                {loading ? 'Loading...' : 'Continue'}
                            </Button>
                            {error && (
                                <Box mt={2} color="error.main">
                                    <Typography color="error" variant="body2">{error}</Typography>
                                </Box>
                            )}
                        </form>
                    </Grid>
                ) : (
                    companyDetails && (
                        <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>
                            <WebsiteVerificationCard 
								companyDetails={companyDetails} 
								updateStage={() => {}} 
								guest
							/>
                        </Grid>
                    )
                )}
            </Grid>
        </Container>
    );
}
